import api from "./api";

export function countTaskResult(taskId) {
  let endpoint = process.env.REACT_APP_DATA_MANAGER_ENDPOINT

  return api.get(endpoint + '/message/' + taskId)
}

export function getMessageHistory(search) {
  let endpoint = process.env.REACT_APP_DATA_MANAGER_ENDPOINT

  return api.post(endpoint + '/message',
    {
      "taskId": search['taskId'],
      "deviceId": search['deviceId'],
      "jobType": Array.from(search['jobType']),
      "roundNum": search['roundNum'],
      'result': Array.from(search['result'])
    }
  )
}

export function getMessageHistoryTimeLineCounting(search, timeline) {
  let endpoint = process.env.REACT_APP_DATA_MANAGER_ENDPOINT

  return api.post(endpoint + `/message/timeline/${timeline}`,
    {
      "taskId": search['taskId'],
      "jobType": Array.from(search['jobType']),
      "roundNum": search['roundNum'],
      'result': Array.from(search['result'])
    }
  )
}
